module.exports = __webpack_public_path__ + "img/monoxid-sensor-lg-ok.6a2fec7b.svg";